<template>
    <div>
        <b-modal
            no-close-on-esc
            no-close-on-backdrop
            size="xl"
            dialog-class="modal-90w"
            hide-footer
            v-model="showModal"
            :title="getTitle"
            scrollable
            @hidden="$_hideModal"
        >
            <div class="row form-group search-container">
                <!-- Search field -->
                <search-box
                    id="searchFeedbackLogs"
                    info="Meldingsnummer"
                    :autofocus="true"
                    :value="meldingsnummer"
                    :saveInState="true"
                    @input="$_onSearchInput"
                    extendedClass="col-md-2"
                >
                </search-box>
                <b-button style="height: 36px" @click="this.$_showModal"
                    >Zoeken</b-button
                >
            </div>
            <div>
                <b-table
                    :busy="loading"
                    striped:hover
                    :items="logData"
                    :fields="fields"
                >
                    <template #cell(location)="data">
                        <div
                            style="max-width: 500px; cursor: pointer"
                            @click="$_toggleLocations"
                            :title="locationToggleTitle"
                        >
                            {{
                                showFullLocation
                                    ? data.value
                                    : $_truncateLocation(data.value)
                            }}
                        </div>
                    </template>
                </b-table>

                <b-pagination
                    v-model="currentPage"
                    :per-page="pageSize"
                    :total-rows="totalItems"
                    align="center"
                    class="my-3"
                ></b-pagination>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import SearchBox from '../../components/SearchBox.vue';
    export default {
        name: 'feedback-log',

        props: {
            launchModal: { type: Boolean, required: false, default: false },
            feedbackType: { type: Object, required: false, default: () => {} }
        },
        components: {
            'search-box': SearchBox
        },

        data() {
            return {
                showModal: false,
                loading: false,
                logData: [],
                fields: [],
                currentPage: 1,
                pageSize: 10,
                totalItems: 0,
                meldingsnummer: null,
                showFullLocation: false
            };
        },
        computed: {
            getTitle() {
                return this.feedbackType?.name;
            },
            locationToggleTitle() {
                return this.showFullLocation
                    ? 'Toon afgekorte coördinaten'
                    : 'Toon volledige coördinaten';
            }
        },

        methods: {
            async $_showModal() {
                this.showModal = true;
                this.loading = true;

                let parameters = {
                    feedbackTypeId: this.feedbackType.id,
                    page: this.currentPage,
                    pageSize: this.pageSize
                };

                if (this.meldingsnummer) {
                    parameters.meldingsnummer = this.meldingsnummer;
                }

                // Get table data.
                const response = await this.$store.dispatch('useApiData', {
                    name: 'GetFeedbackLogs',
                    parameters: parameters
                });

                this.logData = response.data.items.map((item) => {
                    let parsed = {};

                    if (item.recordData) {
                        try {
                            parsed = JSON.parse(item.recordData);
                        } catch (e) {
                            console.error('Failed to parse RecordData JSON:', e);
                        }
                    }

                    return {
                        ...item, // keep the existing properties (Id, FeedbackTypeId, etc.)
                        ...parsed // spread JSON properties on top
                    };
                });

                const fixedOrder = [
                    'id',
                    'feedbackTypeId',
                    'meldingsnummer',
                    'aanmaker',
                    'aanmaakkDatum',
                    'gewijzigdDoor',
                    'wijzigingsDatum',
                    'verwijderdDoor',
                    'verwijderDatum',
                    'status'
                ];

                const allKeys = new Set();
                this.logData.forEach((row) => {
                    Object.keys(row).forEach((k) => allKeys.add(k));
                });

                // Filter JSON-only keys
                const jsonKeys = Array.from(allKeys).filter(
                    (k) => !fixedOrder.includes(k)
                );

                this.fields = [
                    ...fixedOrder.map((k) => ({ key: k, label: k })),
                    ...jsonKeys
                        .filter((k) => k !== 'recordData') // remove recordData here
                        .map((k) => ({ key: k, label: k }))
                ];

                this.totalItems = response.data.totalCount;

                this.loading = false;
            },

            $_hideModal() {
                this.showModal = false;
                this.$emit('close');
            },
            $_onSearchInput(value) {
                this.meldingsnummer = value;
            },
            $_toggleLocations() {
                this.showFullLocation = !this.showFullLocation;
            },
            $_truncateLocation(location) {
                if (!location) return '';
                const maxLength = 20; // adjust to your preferred truncation
                return location.length > maxLength
                    ? location.substring(0, maxLength) + '…'
                    : location;
            }
        },

        watch: {
            launchModal(newVal) {
                if (newVal) {
                    this.logData = [];
                    this.currentPage = 1;
                    this.$_showModal();
                }
            },
            currentPage(newVal) {
                this.$_showModal();
            }
        }
    };
</script>

<style >
.modal-dialog.modal-90w {
    max-width: 98% !important;
    width: 98% !important; /* helps if Bootstrap sets fixed widths */
}
</style>
